import { createTheme } from "@material-ui/core";

const theme = createTheme({
  typography: {
    fontFamily: '"Titillium Web", sans-serif',
    useNextVariants: true,
  },
  palette: {
    primary: {
      main: "#542785",
      contrastText: "#fff",
    },
    secondary: {
      main: "#b2006f",
      contrastText: "#fff",
    },
    tertiary: {
      contrastText: "#b2006f",
      main: "#fff",
    },
    timedeposit: {
      main: "#be3090",
    },
  },

  overrides: {
    MuiButton: {
      root: {
        borderRadius: "8px",
        boxShadow: "none!important",
      },
    },
    MuiTableCell: {
      root: {
        padding: "4px 24px",
      },
    },
  },
});

export default theme;
